import {NgModule} from "@angular/core";
import {DatepickerDirective} from './datepicker.directive';

@NgModule({
    declarations: [DatepickerDirective],
    exports     : [DatepickerDirective]
})

export class DatepickerModule {}


// WEBPACK FOOTER //
// ./src/app/directives/datepicker/datepicker.module.ts